<script>
  import { createEventDispatcher } from 'svelte';
  import { fade, scale } from 'svelte/transition';

  let fullName = '';
  let isSubmitting = false;
  let error = null;

  const dispatch = createEventDispatcher();

  async function handleSubmit() {
    if (fullName.trim().length < 3) {
      error = "Doesn't look like a full name";
      return;
    }

    error = null;
    isSubmitting = true;

    try {
      const accessToken = localStorage.getItem('accessToken');
      const response = await fetch('https://groupfruits.online/users/api/UpdateUserProfileView/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWT ${accessToken}`,
        },
        body: JSON.stringify({ full_name: fullName }),
      });

      if (response.ok) {
        dispatch('nameUpdated');
      } else {
        console.error('Error updating full name:', response.statusText);
      }
    } catch (error) {
      console.error('Network error:', error);
    } finally {
      isSubmitting = false;
    }
  }
</script>



<style>
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70vh;
    font-family: 'Poppins', sans-serif;
  }

  .form-container {
    background-color: #fff;
    padding: 5%;
    max-width: 90%;
    width: 100%;
  }

  h2 {
    text-align: center;
    margin-bottom: 1.5rem;
    color: #333;
    font-weight: 600;
    font-size: 1.5rem;
  }

  input[type="text"] {
    width: 100%;
    padding: 0.8rem 1rem;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 1rem;
    outline: none;
    transition: border-color 0.3s ease;
  }

  input[type="text"]:focus {
    border-color: #7c4dff;
  }

  .error {
    color: #ff5555;
    font-size: 0.875rem;
    margin-top: 0.625rem;
  }

  button {
    display: block;
    width: 100%;
    padding: 0.8rem;
    margin-top: 1.5rem;
    background-color: #7c4dff;
    color: #fff;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: background-color 0.3s ease;
  }

  button:hover {
    background-color: #6c3eff;
  }

  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
  }

  .dot {
    width: 0.625rem;
    height: 0.625rem;
    background-color: #7c4dff;
    border-radius: 50%;
    margin: 0 0.3125rem;
    animation: dot-animation 1s infinite;
  }

  .dot:nth-child(2) {
    animation-delay: 0.2s;
  }

  .dot:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes dot-animation {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }

  @media screen and (min-width: 480px) {
    .form-container {
      max-width: 80%;
    }
  }

  @media screen and (min-width: 768px) {
    .form-container {
      max-width: 60%;
    }

    h2 {
      font-size: 1.75rem;
    }

    input[type="text"], button {
      font-size: 1.125rem;
    }
  }

  @media screen and (min-width: 1024px) {
    .form-container {
      max-width: 50%;
    }
  }
</style>

<div class="container">
  <div class="form-container" in:fade={{ duration: 300 }}>
    <h2>Your Name</h2>
    <form on:submit|preventDefault={handleSubmit}>
      <input type="text" placeholder="Full Name" bind:value={fullName} on:focus={() => (error = null)} />
      {#if error}
        <div class="error" in:scale={{ duration: 300 }}>{error}</div>
      {/if}

      <button type="submit" disabled={isSubmitting}>
        {#if isSubmitting}
          <div class="loader">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        {:else}
          Submit
        {/if}
      </button>
    </form>
  </div>
</div>